import { Grid, TableCell, TableRow, Typography } from "@mui/material";
import { FC, useEffect, useMemo, useState } from "react";
import AppCard from "../../components/cards/AppCard";
import { getStakingOverview } from "../../api/platform/platform.staking";
import { IStakingOverview } from "../../common/interfaces/staking.interface";
import BasicTable from "../../components/tables/BasicTable";
import { activeStakingsTableColumnNames } from "../../common/constants/clubs.constants";
import { StakePeriodTypeLabel } from "../../common/enums/club.enums";

const PlatformStaking: FC = () => {
  const [stakingOverview, setStakingOverview] = useState<IStakingOverview>();
  const [cardLoader, setCardLoader] = useState<boolean>(false);

  useEffect(() => {
    void getStakingOverviewFromApi();
  }, []);

  const getStakingOverviewFromApi = async () => {
    try {
      setCardLoader(true);
      setStakingOverview(await getStakingOverview());
      setCardLoader(false);
    } catch (error) {
      console.log(error);
    }
  };

  const renderActiveStakingTable = useMemo(() => {
    return stakingOverview?.activeStakings.map((row, index) => (
      <TableRow
        key={index}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{row.count}</TableCell>
        <TableCell>{StakePeriodTypeLabel[row.stakePeriodType]}</TableCell>
      </TableRow>
    ));
  }, [stakingOverview]);
  const renderTotalStakingTable = useMemo(() => {
    return stakingOverview?.totalStakings.map((row, index) => (
      <TableRow
        key={index}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{row.count}</TableCell>
        <TableCell>{StakePeriodTypeLabel[row.stakePeriodType]}</TableCell>
      </TableRow>
    ));
  }, [stakingOverview]);

  const totalNumberOfActiveStakings = useMemo(() => {
    return stakingOverview && stakingOverview.totalNumberOfActiveStakings;
  }, [stakingOverview]);

  const totalNumberOfStakings = useMemo(() => {
    return stakingOverview ? stakingOverview.totalNumberOfStakings : 0;
  }, [stakingOverview]);

  const totalStakedAmount = useMemo(() => {
    return stakingOverview && stakingOverview.totalStakedAmount;
  }, [stakingOverview]);

  return (
    <div>
      <Grid
        container
        spacing={{ xs: 1, md: 2, sm: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        <Typography
          variant="h4"
          component="span"
          key={`typography1`}
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 1,
            width: "100%",
          }}
        >
          Staking
        </Typography>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total number of active stakings"}
            value={`${totalNumberOfActiveStakings}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total number of stakings"}
            value={`${totalNumberOfStakings}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <AppCard
            label={"Total staked amount"}
            value={`${totalStakedAmount}`}
            loader={cardLoader}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          {stakingOverview && renderActiveStakingTable && (
            <>
              <Typography
                variant="h5"
                component="span"
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  padding: 1,
                  width: "100%",
                }}
              >
                Active stakings
              </Typography>
              <BasicTable
                renderTableItems={renderActiveStakingTable}
                titles={activeStakingsTableColumnNames}
                loader={false}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          {stakingOverview && renderTotalStakingTable && (
            <>
              <Typography
                variant="h5"
                component="span"
                sx={{
                  display: "flex",
                  justifyContent: "start",
                  padding: 1,
                  width: "100%",
                }}
              >
                Total stakings
              </Typography>
              <BasicTable
                renderTableItems={renderTotalStakingTable}
                titles={activeStakingsTableColumnNames}
                loader={false}
              />
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default PlatformStaking;
